/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import useParametrosPago from "redux/hooks/useParametrosPago";
import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import useUsuario from "hooks/useUsuario";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { consumirServicioEncirptacion } from "api";
import { ambienteAplicacion, urlResumenCotizadorMex } from "constants/urls";
import Loading from "wrappers/Loading";
import { MarineInland } from "./constantes/general";
// import { enviar } from "./funcionesPrueba";

const RecuperarMarineInland = () => {
  // const { fetchParametros } = useParametrosPago();
  const { addWarningToast } = useCustomToast();
  const usuario = useUsuario();
  const { id: idCotizacion } = useQueryParams();
  const history = useCustomRouter();

  // const { parametrosPago } = useSelector(({ cotizacionReducer }) => {
  //   return {
  //     parametrosPago: cotizacionReducer?.parametrosPago,
  //   };
  // });

  const getData = async () => {
    // if (!parametrosPago) {
      // await fetchParametros();
    // }

    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
      usuCotiza: { usuCodigo: usuario?.cliCodigoCore },
    };    
    let resRecuperar;    
      resRecuperar = await consumirServicioEncirptacion(
        urlResumenCotizadorMex,
        DataResumen
      );
    
    if (resRecuperar.transaccion) {            
        
        switch (resRecuperar.cotConsulta.pasoCarrito) {
          case "crearLead":
            return history.push(
              `${MarineInland.urls.ingresoEquipos}/${idCotizacion}?back=true`            
            );

          case "guardarMaquinaria":
            return history.push(
              `${MarineInland.urls.opcionPago}/${idCotizacion}`            
            );

          default:            
            break;
        }
        addWarningToast('No se ha podido recuperar la cotización por favor intente nuevamente.');
        return history.push("/");
      }     
     else {
      addWarningToast("Ha ocurrido un problema al recuperar la cotización");
      history.goBack();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Loading loading={true} message="Recuperando...">
      <h1>Recuperando...</h1>
    </Loading>
  );
};
export default RecuperarMarineInland;
